import { actionTypes } from "./actions";

const initialState = {
  data: [],
  company: [],
  partnerTypes: []
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_DISTRIBUTOR_OPTIONS:
    case actionTypes.SET_PARTNERS:
      return {
        ...state,
        data: payload,
      };

    case actionTypes.SET_COMPANY:
      return {
        ...state,
        company: payload,
      };

    case actionTypes.SET_PARTNER_TYPES:
      return {
        ...state,
        partnerTypes: payload,
      };

    default:
      return {
        ...state,
      };
  }
};
